export default __webpack_public_path__ + "img/city_seal.bc103033.png";